import { Add, Delete, Edit, Quiz, UploadFile, ArrowBack, Download } from "@mui/icons-material";
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import {
  Grid,
  IconButton,
  Skeleton,
  Stack,
  TableCell,
  Tooltip,
  Typography,
} from "@mui/material";
import EmptyContent from "components/EmptyContent";
import List from "components/UI/List";
import { useAlert } from "contexts/alertContext";
import { Feature } from "models/api";
import {
  IImportQuestionsInput,
  IVendorAssessmentQuestion,
  IVendorAssessmentQuestionInput,
} from "models/vendorAssessmentQuestion";
import React, { useCallback, useEffect, useState } from "react";
import { QueryClient, useMutation } from "react-query";

import {
  VendorAssessmentQuestionCells,
  addVendorAssessmentQuestion,
  deleteVendorAssessmentQuestion,
  editVendorAssessmentQuestion,
  getVendorAssessmentQuestions,
    importExcel,
    exportQuestionsPdf,
    exportQuestionsExcel,
} from "framework/vendorAssessmentQuestion";
import { Menu, MenuItem } from "@mui/material";
import { getVendorAssessmentDefinitionById } from "framework/vendorAssessmentDefinition";
import AddVendorAssessmentQuestion from "./partials/AddVendorAssessmentQuestion/AddVendorAssessmentQuestion";
import BlockIcon from "@mui/icons-material/Block";
import EditVendorAssessmentQuestion from "./partials/EditVendorAssessmentQuestion/EditVendorAssessmentQuestion";
import DeleteVendorAssessmentQuestion from "./partials/DeleteVendorAssessmentQuestion/DeleteVendorAssessmentQuestion";
import { handleError } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { IPermission } from "models/permissions";
import { getPermission } from "helpers";
import { Link, useParams, useNavigate } from "react-router-dom";
import { IEvaluationQuestionType } from "models/app";
import { ICompanyCompetency } from "models/companyCompetencies";
import ImportQuestions from "./partials/ImportQuestions/ImportQuestions";
import { IVendorAssessmentDefinition } from "models/vendorAssessmentDefinition";

interface Props {
  feature: Feature;
}

const VendorAssessmentQuestion: React.FC<Props> = ({ feature }) => {
  let typesOptions: IEvaluationQuestionType[] = [
    {
      id: 1,
      description: "Choice",
      descriptionAr: "",
    },
    {
      id: 2,
      description: "Open text",
      descriptionAr: "",
    },
  ];
  const urlParams = useParams();
  const navigate = useNavigate();
  let id: string = urlParams[`${feature.singleName}Id`] as string;
  const [loading, setLoading] = useState<boolean>(true);
  const [loading3, setLoading3] = useState<boolean>(true);
  const { t, i18n } = useTranslation();
  const [permission, setPermission] = useState<IPermission | null>(null);
  const [loading2, setLoading2] = useState<boolean>(false);
  const [VendorAssessmentQuestion, setVendorAssessmentQuestion] = useState<
    IVendorAssessmentQuestion[]
  >([] as IVendorAssessmentQuestion[]);
  const [FilterVendorAssessmentQuestion, setFilterVendorAssessmentQuestion] =
    useState<IVendorAssessmentQuestion[]>([] as IVendorAssessmentQuestion[]);
  const [assessmentDefinition, setAssessmentDefinition] = useState<IVendorAssessmentDefinition | null>(null);

  const [openAdd, setOpenAdd] = useState<boolean>(false);
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [openImportQuestions, setOpenImport] = useState<boolean>(false);
  const [
    selectedVendorAssessmentQuestion,
    setSelectedVendorAssessmentQuestion,
  ] = useState<IVendorAssessmentQuestion>({} as IVendorAssessmentQuestion);
  const [inputObj, setInputObj] = useState<IVendorAssessmentQuestionInput>(
    {} as IVendorAssessmentQuestionInput
  );
  const [importQuestionsInputObj, setImportQuestionsInputObj] = useState<IImportQuestionsInput>(
    {} as IImportQuestionsInput
  );

  const { setAlert } = useAlert();
  const [exportMenuAnchor, setExportMenuAnchor] = useState<null | HTMLElement>(null);

  // eslint-disable-next-line
  const queryClient = new QueryClient();

  const addVendorAssessmentQuestionMutation = useMutation({
    mutationFn: (createInput: IVendorAssessmentQuestionInput) => {
      return addVendorAssessmentQuestion(createInput);
    },
  });

  const editVendorAssessmentQuestionMutation = useMutation({
    mutationFn: (data: {
      createInput: IVendorAssessmentQuestionInput;
      id: string;
    }) => {
      return editVendorAssessmentQuestion(data.createInput, data.id);
    },
  });

  const importExcelMutation = useMutation({
    mutationFn: (createInput: FormData) => {
      return importExcel(createInput, id);
    },
  });

  const deleteVendorAssessmentQuestionMutation = useMutation({
    mutationFn: (data: { id: string }) => {
      return deleteVendorAssessmentQuestion(data.id);
    },
  });

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      let response: any = await queryClient.fetchQuery(
        "get vendor assessment questions",
        () =>
          getVendorAssessmentQuestions(`/byassessment?vendorAssessmentId=${id}`)
      );
      response =
        response && response.length > 0
          ? response.map((item: IVendorAssessmentQuestion) => ({
            ...item,
          }))
          : [];
      setVendorAssessmentQuestion(response);
      setFilterVendorAssessmentQuestion(response);
      setLoading(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading(false);
    }

    // eslint-disable-next-line
  }, [queryClient, setAlert]);

  // const fetchCompetencies = useCallback(async () => {
  //   setLoading(true);
  //   try {
  //     let response: any = await queryClient.fetchQuery("get competencies", () =>
  //       getCompanyCompetencies("/bycompany")
  //     );
  //     response =
  //       response && response.length > 0
  //         ? response.map((item: IVendorAssessmentQuestion) => ({
  //             ...item,
  //           }))
  //         : [];
  //     setCompetencies(response);
  //     setLoading(false);
  //   } catch (error: any) {
  //     setAlert({
  //       open: true,
  //       message: handleError(error) || "Something went wrong",
  //       type: "error",
  //     });
  //     setLoading(false);
  //   }

  //   // eslint-disable-next-line
  // }, [queryClient, setAlert]);

  const fetchPermission = useCallback(async () => {
    setLoading3(true);
    try {
      const res = await getPermission(40);
      setPermission(res);
      setLoading3(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading3(false);
    }

    // eslint-disable-next-line
  }, [queryClient, setAlert]);

  const fetchAssessmentDefinition = useCallback(async () => {
    try {
      const res = await getVendorAssessmentDefinitionById(id);
      setAssessmentDefinition(res);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
    }
    // eslint-disable-next-line
  }, [id, setAlert]);

  useEffect(() => {
    fetchData();
    // fetchCompetencies();
    fetchPermission();
    fetchAssessmentDefinition();
    // eslint-disable-next-line
  }, []);

  if (loading || loading3)
    return (
      <Stack spacing={2} p={2}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton variant="rectangular" key={i} width="100%" height={30} />
        ))}
      </Stack>
    );

  const handleChange = (name: string, value: any) => {
    if (name == "questionOrder" || name == "type") {
      value = parseInt(value);
    }
    setInputObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);

  const handleOpenEdit = (
    VendorAssessmentQuestion: IVendorAssessmentQuestion
  ) => {
    setSelectedVendorAssessmentQuestion(VendorAssessmentQuestion);
    setOpenEdit(true);
  };
  const handleCloseEdit = () => {
    setOpenEdit(false);
    setSelectedVendorAssessmentQuestion({} as IVendorAssessmentQuestion);
  };

  const handleCloseImport = () => {
    setOpenImport(false);
  };

  const handleOpenDelete = (
    VendorAssessmentQuestion: IVendorAssessmentQuestion
  ) => {
    setSelectedVendorAssessmentQuestion(VendorAssessmentQuestion);
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setSelectedVendorAssessmentQuestion({} as IVendorAssessmentQuestion);
  };

  const handleOpenImport = () => {
    setOpenImport(true);
  };

  const handleDownloadPdf = async () => {
    try {
      setLoading2(true);
      const blob = await exportQuestionsPdf(id);
      const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      const title = assessmentDefinition ? (i18n.language === "en" ? assessmentDefinition.title : (assessmentDefinition.titleAr || assessmentDefinition.title)) : 'Assessment';
      link.download = `${title?.replace(/\s+/g, '-')}-Questions.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setLoading2(false);
    } catch (error: any) {
      setAlert({ open: true, message: handleError(error) || 'Download failed', type: 'error' });
      setLoading2(false);
    }
  };

  const handleDownloadExcel = async () => {
    try {
      setLoading2(true);
      const blob = await exportQuestionsExcel(id);
      const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
      const link = document.createElement('a');
      link.href = url;
      const title = assessmentDefinition ? (i18n.language === "en" ? assessmentDefinition.title : (assessmentDefinition.titleAr || assessmentDefinition.title)) : 'Assessment';
      link.download = `${title?.replace(/\s+/g, '-')}-Questions.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setLoading2(false);
    } catch (error: any) {
      setAlert({ open: true, message: handleError(error) || 'Download failed', type: 'error' });
      setLoading2(false);
    }
  };

  const openExportMenu = (e: React.MouseEvent<HTMLButtonElement>) => setExportMenuAnchor(e.currentTarget);
  const closeExportMenu = () => setExportMenuAnchor(null);

  const getBodyCells = (row: IVendorAssessmentQuestion) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "title")
        return {
          id: "title",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.title}</Typography>
            </TableCell>
          ),
        };

      if (key === "titleAr")
        return {
          id: "titleAr",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.titleAr}</Typography>
            </TableCell>
          ),
        };

      // if (key === "competencyName")
      //   return {
      //     id: "competencyName",
      //     element: (
      //       <TableCell align={"left"} key={i}>
      //         <Typography variant="body2">{row.competencyName}</Typography>
      //       </TableCell>
      //     ),
      //   };

      if (key === "description")
        return {
          id: "description",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.description}</Typography>
            </TableCell>
          ),
        };

      if (key === "descriptionAr")
        return {
          id: "descriptionAr",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.descriptionAr}</Typography>
            </TableCell>
          ),
        };

      if (key === "questionOrder")
        return {
          id: "questionOrder",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row.questionOrder}</Typography>
            </TableCell>
          ),
        };

      if (key === "questionType")
        return {
          id: "questionType",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">
                {row.questionType.toString() == "1" ? "MCQ" : "Open Text"}
              </Typography>
            </TableCell>
          ),
        };

      if (key === "id")
        return {
          id: "actions",
          element: (
            <TableCell align={"right"} key={i}>
              <Stack
                direction={"row"}
                alignContent={"center"}
                justifyContent={i18n.language === "en" ? "start" : "end"}
                spacing={1}
              >
                {permission?.hasModifyPermission && (
                  <Tooltip title={t("T_edit")}>
                    <IconButton
                      size={"small"}
                      color={"primary"}
                      onClick={() => handleOpenEdit(row)}
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                )}

                {permission?.hasDeletePermission && (
                  <Tooltip title={t("T_delete")}>
                    <IconButton
                      size={"small"}
                      color={"error"}
                      onClick={() => handleOpenDelete(row)}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                )}

                <Tooltip title={t("T_questions")}>
                  <Link to={`/vendorAssessmentQuestionOptions/${row.id}`}>
                    <IconButton size={"small"} color={"info"}>
                      <Quiz />
                    </IconButton>
                  </Link>
                </Tooltip>
              </Stack>
            </TableCell>
          ),
        };
    });
    return cells;
  };

  const handleAdd = async () => {
    if (
      !inputObj.title ||
      !inputObj.questionOrder ||
      !inputObj.questionType
    )
      return setAlert({
        open: true,
        message: "Please fill all fields",
        type: "error",
      });
    try {
      setLoading2(true);
      inputObj.definitionId = id;
      await addVendorAssessmentQuestionMutation.mutateAsync(inputObj);
      setAlert({
        open: true,
        message: "VendorAssessmentQuestion added successfully",
        type: "success",
      });
      fetchData();
      handleCloseAdd();
      setInputObj({} as IVendorAssessmentQuestionInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleEdit = async () => {
    try {
      setLoading2(true);
      let createInput: IVendorAssessmentQuestionInput = {
        definitionId: id,
        title: inputObj.title || selectedVendorAssessmentQuestion.title,
        titleAr: inputObj.titleAr === null ? '' : inputObj.titleAr || selectedVendorAssessmentQuestion.titleAr,
        description:
          inputObj.description === null ? '' : inputObj.description || selectedVendorAssessmentQuestion.description,
        descriptionAr:
          inputObj.descriptionAr === null ? '' : inputObj.descriptionAr ||
          selectedVendorAssessmentQuestion.descriptionAr,
        questionOrder:
          inputObj.questionOrder ||
          selectedVendorAssessmentQuestion.questionOrder,
        questionType:
          inputObj.questionType ||
          selectedVendorAssessmentQuestion.questionType,
        // competencyId:
        //   inputObj.competencyId ||
        //   selectedVendorAssessmentQuestion.competencyId,
      };
      await editVendorAssessmentQuestionMutation.mutateAsync({
        createInput,
        id: selectedVendorAssessmentQuestion.id,
      });
      setAlert({
        open: true,
        message: "VendorAssessmentQuestion updated successfully",
        type: "success",
      });
      fetchData();
      handleCloseEdit();
      setInputObj({} as IVendorAssessmentQuestionInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading2(true);
      await deleteVendorAssessmentQuestionMutation.mutateAsync({
        id: selectedVendorAssessmentQuestion.id,
      });
      setAlert({
        open: true,
        message: "VendorAssessmentQuestion deleted successfully",
        type: "success",
      });
      fetchData();
      handleCloseDelete();
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };

  function handleImprotQuestionsChange(name: string, value: any): void {
    setImportQuestionsInputObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  async function handleImportQuestions(): Promise<void> {
    try {
      setLoading2(true);
      const createInput = new FormData();
      // createInput.append("definitionId", id);
      if (importQuestionsInputObj.excelFile) createInput.append("ExcelFile", importQuestionsInputObj.excelFile[0] || importQuestionsInputObj.excelFile);
      await importExcelMutation.mutateAsync(createInput);
      setAlert({
        open: true,
        message: "Questions imported successfully",
        type: "success",
      });
      fetchData();
      handleCloseImport();
      setImportQuestionsInputObj({} as IImportQuestionsInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  }

  return (
    <>
      <Stack spacing={2} p={2}>
        <Grid
          container
          justifyContent={"space-between"}
          alignItems="center"
          sx={{ mb: 2 }}
        >
          <Stack direction={"row"} spacing={2} alignItems={"center"}>
            <Tooltip title={t("T_back_to_assessments") || "Back to Assessments"}>
              <IconButton
                sx={{
                  color: "primary.main",
                  "&:hover": {
                    bgcolor: "primary.light",
                    color: "white",
                  },
                  height: 40,
                  width: 40,
                  transition: "0.5s",
                }}
                onClick={() => navigate("/vendorAssessmentDefinition")}
              >
                <ArrowBack />
              </IconButton>
            </Tooltip>
            <div>
              <Typography variant="h3" color={"header.primary"}>
                {t(feature.name)}
              </Typography>
              {assessmentDefinition && (
                <Typography variant="body2" color={"text.secondary"} sx={{ mt: 0.5 }}>
                  {i18n.language === "en" ? assessmentDefinition.title : assessmentDefinition.titleAr || assessmentDefinition.title}
                </Typography>
              )}
            </div>
          </Stack>
          <Stack direction={"row"} spacing={1}>
            {permission?.hasModifyPermission && (
              <Tooltip title={t("T_add")}>
                <IconButton
                  sx={{
                    // bgcolor: 'primary.main',
                    color: "primary.main",
                    "&:hover": {
                      bgcolor: "primary.light",
                      color: "white",
                    },
                    height: 40,
                    width: 40,
                    transition: "0.5s",
                  }}
                  onClick={handleOpenAdd}
                >
                  <Add />
                </IconButton>
              </Tooltip>
            )}
            {permission?.hasModifyPermission && (
              <Tooltip title={t("T_import_questions")}>
                <IconButton
                  sx={{
                    // bgcolor: 'primary.main',
                    color: "primary.main",
                    "&:hover": {
                      bgcolor: "primary.light",
                      color: "white",
                    },
                    height: 40,
                    width: 40,
                    transition: "0.5s",
                  }}
                  onClick={handleOpenImport}
                >
                  <UploadFile />
                </IconButton>
              </Tooltip>
            )}
            {permission?.hasReadPermission && (
              <>
                <Tooltip title={"Export"}>
                  <IconButton
                    sx={{
                      color: "primary.main",
                      "&:hover": {
                        bgcolor: "primary.light",
                        color: "white",
                      },
                      height: 40,
                      width: 40,
                      transition: "0.5s",
                    }}
                    onClick={openExportMenu}
                  >
                    <Download />
                  </IconButton>
                </Tooltip>
                <Menu anchorEl={exportMenuAnchor} open={!!exportMenuAnchor} onClose={closeExportMenu}>
                  <MenuItem onClick={() => { closeExportMenu(); handleDownloadPdf(); }}>Download PDF</MenuItem>
                  <MenuItem onClick={() => { closeExportMenu(); handleDownloadExcel(); }}>Download Excel</MenuItem>
                </Menu>
              </>
            )}
          </Stack>
        </Grid>

        {permission?.hasReadPermission! &&
          FilterVendorAssessmentQuestion.length > 0 && (
            <List
              headCells={VendorAssessmentQuestionCells}
              data={FilterVendorAssessmentQuestion}
              getBodyCells={getBodyCells}
              feature={feature}
              canEdit={false}
            />
          )}
        {(!FilterVendorAssessmentQuestion ||
          FilterVendorAssessmentQuestion.length === 0) &&
          permission?.hasReadPermission! && (
            <EmptyContent
              icon={<BlindsClosedIcon sx={{ fontSize: "3.5rem " }} />}
              header={t("T_no_vendor_assessment_questions")}
              message={t("T_no_vendor_assessment_questions")}
            />
          )}
        {!permission?.hasReadPermission && (
          <EmptyContent
            icon={<BlockIcon sx={{ fontSize: "3.5rem " }} />}
            header={t("T_no_permissions")}
            message={t("T_no_permissions_message")}
          />
        )}
      </Stack>

      {openAdd && (
        <AddVendorAssessmentQuestion
          open={openAdd}
          loading={loading2}
          types={typesOptions}
          onClose={handleCloseAdd}
          onSubmit={handleAdd}
          onChanges={handleChange}
        />
      )}
      {openEdit && (
        <EditVendorAssessmentQuestion
          open={openEdit}
          loading={loading2}
          types={typesOptions}
          vendorAssessmentQuestion={selectedVendorAssessmentQuestion}
          onClose={handleCloseEdit}
          onSubmit={handleEdit}
          onChanges={handleChange}
        />
      )}
      {openDelete && (
        <DeleteVendorAssessmentQuestion
          open={openDelete}
          loading={loading2}
          onClose={handleCloseDelete}
          onSubmit={handleDelete}
        />
      )}

      {openImportQuestions && (
        <ImportQuestions
          open={openImportQuestions}
          loading={loading2}
          onClose={handleCloseImport}
          onSubmit={handleImportQuestions}
          onChanges={handleImprotQuestionsChange} />
      )}

    </>
  );
};

export default VendorAssessmentQuestion;
